import { brandColors } from './basicPalette'
import { getImageVariant } from './getImageVariant'

export const getEmailTemplateStyleProps = (org: {
  styles: { colors?: any; logo?: any }
  name?: string | null
}) => {
  const companyName = org.name ?? ''
  const backgroundColor =
    org.styles.colors?.navbarBackground || brandColors.navbarBackground
  const linkColor = org.styles.colors?.linkText || brandColors.linkText
  const buttonPrimary =
    org.styles.colors?.buttonPrimary || brandColors.buttonPrimary.default
  const logoSrc = getImageVariant(org.styles.logo, '300x200')

  const emailTemplateProps = {
    backgroundColor,
    linkColor,
    buttonPrimary,
    logoSrc,
    companyName
  }
  return emailTemplateProps
}
